import "./strength.scss";
import { Heading, ContentCards } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
import { strengths } from "../../services/data";
import { Helmet } from "react-helmet-async";
export default function Strengths() {

    const lightmode = useAppSelector((state) => state.mode.lightMode);
    return <div className="strengths">
        <Helmet>
            <title>Strengths - PBL Transport</title>
            <meta
                name="description"
                content="Explore PBL's strengths in logistics and heavy cargo transport: in-house workshop, expert personnel, mobile service units, ODC handling, route mapping, and advanced technology."
            />
            <meta
                name="keywords"
                content="logistics, heavy cargo, PBL, ODC transport, mobile service units, ERP fleet management, route mapping surveys, heavy lift consignments, trailer tracking, air suspension, ISO 9001, ISO 45001"
            />
        </Helmet>
        <div className="headings">
            <Heading heading="Strengths" lightMode={lightmode} /></div>
        {strengths.map((item, i) => <ContentCards key={i} {...item} />)}
    </div>
}